import React from 'react';

const Download = () => {
    return (
        <div className='mb-20 mt-4'>
            <a href='Merazur_Rahman.pdf' download className="btn btn-primary bg-gradient-to-r from-sky-400 to-sky-900 text-white">
            Download CV
          </a>
        </div>
    );
};

export default Download;